<template>
  <div id="download">
    <nav-bar :title="`${$store.state.appInfo.title}下载`" :show="true" />
    <main>
      <header>
        <img :src="$store.state.appInfo.appLogoUrl" alt="" />
        <h3>{{ $store.state.appInfo.title }}</h3>
      </header>
      <p @click="download('ios')">
        <img src="../assets/images/ios.png" alt="" />
        <span>IOS下载</span>
      </p>
      <p @click="download('android')">
        <img src="../assets/images/android.png" alt="" />
        <span>安卓下载</span>
      </p>
      <div>
        <p>V{{ $store.state.appInfo.version }}</p>
        <p>更新时间：{{ dateFormat($store.state.appInfo.releaseTime) }}</p>
      </div>
    </main>
    <van-popup v-model="showGuide" @click="showGuide = false">
      <img src="../assets/images/guide.png" alt="" />
    </van-popup>
  </div>
</template>

<script>
  export default {
    name: 'Download',
    data() {
      return {
        showGuide: false
      };
    },
    methods: {
      dateFormat(val) {
        let date = new Date(val);
        let month =
          date.getMonth() + 1 >= 10
            ? date.getMonth() + 1
            : '0' + (date.getMonth() + 1);
        let day = date.getDate() >= 10 ? date.getDate() : '0' + date.getDate();
        return date.getFullYear() + '.' + month + '.' + day;
      },
      download(system) {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          this.showGuide = true;
        } else {
          switch (system) {
            case 'ios':
              window.open(
                'https://apps.apple.com/cn/app/%E5%95%86%E4%BA%92%E9%80%9A%E5%B9%B3%E5%8F%B0/id1617036314'
              );
              break;
            default:
              const url = this.$store.state.appInfo.download.android;

              var iframe = document.createElement('iframe');
              iframe.style.display = 'none';
              iframe.src =
                'javascript: \'<script>location.href="' + url + '"<\/script>\'';
              document.getElementsByTagName('body')[0].appendChild(iframe);
          }
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  #download {
    > main {
      > header {
        text-align: center;
        > img {
          width: 104px;
          height: 104px;
          margin: 60.5px 0 0;
        }
        > h3 {
          font-size: 24px;
          color: #999999;
          margin: 15px 0 68.5px;
        }
      }
      > p {
        width: 285px;
        height: 44px;
        line-height: 44px;
        font-size: 15px;
        color: #004ea9;
        text-align: center;
        border-radius: 5px;
        border: 1px solid #004ea9;
        margin: 0 auto;
        > img {
          width: 13.5px;
          height: 14px;
          margin-right: 5px;
          position: relative;
          top: 1px;
        }
        &:nth-of-type(1) {
          margin-bottom: 10px;
          > img {
            width: 12px;
          }
        }
      }
      > div {
        width: 100%;
        position: absolute;
        bottom: 25px;
        > p {
          font-size: 14px;
          color: #666666;
          text-align: center;
          margin: 0;
          &:nth-of-type(1) {
            margin-bottom: 10px;
          }
        }
      }
    }
    .van-popup {
      width: 100vw;
      height: 100vh;
      text-align: center;
      background: rgba(0, 0, 0, 0);
      > img {
        width: 297px;
        height: 261px;
        margin-top: 10px;
      }
    }
  }
</style>
